import { useSelector } from 'react-redux'
import { RootState } from '../store'
import axios, { AxiosRequestConfig } from 'axios/index'
import { isAxiosError } from 'axios'

const useAxios = () => {
  const { authenticated, token } = useSelector((state: RootState) => state.app)

  const instance = axios.create({
    baseURL: '/wp-json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  // TODO: Extract and reuse instance helper
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    config.headers = config.headers ?? {}

    if (authenticated) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isAxiosError(error) && error.response?.status === 401) {
        // TODO: Use a context and show modal / with action to login
        // history.push(PageURLs.Login, {
        //   redirectTo: location.pathname,
        // })
      }

      return Promise.reject(error)
    }
  )

  return instance
}

export default useAxios
